
import { defineComponent, PropType } from 'vue'
import { iXMLATemplate } from '../../DocumentDetails'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import descriptor from './DocumentDetailOlapDesignerDialogDescriptor.json'

export default defineComponent({
    name: 'document-detail-xmla-form',
    components: { Column, DataTable },
    props: { xmlModel: { type: Object as PropType<iXMLATemplate> } },
    data() {
        return {
            descriptor,
            model: {} as iXMLATemplate
        }
    },
    watch: {
        xmlModel() {
            this.loadModel()
        }
    },
    created() {
        this.loadModel()
    },
    methods: {
        loadModel() {
            this.model = this.xmlModel as iXMLATemplate
        },
        addParameter() {
            this.model.parameters.push({ name: '', value: '' })
        },
        deleteParameter(index: number) {
            this.model.parameters.splice(index, 1)
        }
    }
})
